import { useMemo } from "react";
let idCounter = 0;
export const resetIdCounter = () => {
    idCounter = 0;
};
/** If no default id is provided, generates a unique one */
const useUniqueId = (prefix = "", defaultId) => useMemo(() => {
    if (defaultId) {
        return defaultId;
    }
    ++idCounter;
    return `${prefix}${idCounter}`;
}, [defaultId]);
export default useUniqueId;
//# sourceMappingURL=useUniqueId.js.map